<template>
    <div class="customerCenter">
        <div class="page_top">
            <div class="title" >
<!--                <i class="icon" id="icon"></i>-->
                <span class="header-text">顧客中心</span>
            </div>
        </div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="訂單查詢" name="first">
                <div class="page_padding" v-infinite-scroll="load" v-loading="loading"
                     element-loading-spinner="el-icon-loading">
                    <div class="container-fluid mt-2">
                        <el-input placeholder="請輸入訂單號碼或商品名稱" v-model="searchData.search"  clearable @clear="search()">
                            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
                        </el-input>
                        <el-empty description="尚無訂單" v-if="orders.length == 0 && loading == false"></el-empty>
                        <!--訂單列表-->
                        <el-card class="box-card my-3" v-for="(order,index) in orders" :key="index">
                            <div @click="goToOrderDetail(order.id)">
                                <div class="d-flex justify-content-between">
                                    <span class="fw-bold ">訂單編號：{{ order.orderNumber }}</span>
                                    <div style="color: #606266">
                                        <span style="font-size: 0.9rem" v-if="order.orderStatus ==5"
                                              class="text-danger">{{ order.orderStatusName }}</span>
                                        <span style="font-size: 0.9rem" v-else>{{ order.orderStatusName }}</span>
                                        <i class="el-icon-arrow-right"></i>
                                    </div>
                                </div>
                                <el-divider></el-divider>
                                <div>
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex flex-column">
                                            <span style="color: #909399;font-size: 0.8rem">訂單日期:{{
                                                    order.createdAt
                                                }}</span>
                                            <span class="mt-1" style="color: #909399;font-size: 0.8rem">付款方式:{{order.paymentTypeName}}</span>
                                        </div>

                                        <el-tag v-if="order.payStatus==1">{{ order.payStatusName }}</el-tag>
                                        <el-tag v-else type="danger">{{ order.payStatusName }}</el-tag>
                                    </div>
                                    <p class="mt-2 fw-bold" style="font-size: 0.9rem">{{ order.title }}</p>
                                </div>
                                <el-divider></el-divider>
                                <div class="d-flex justify-content-between" style="font-size: 0.9rem">
                                    <span style="color: #606266">訂單金額</span>
                                    <span class="fw-bold text-danger ">${{ order.totalAmount.toLocaleString() }}</span>
                                </div>
                            </div>
                        </el-card>
                        <div class="d-flex justify-content-center ">
                            <i class="el-icon-loading fs-5" v-if="loading == false && loadPage == true"></i>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!--        </div>-->

        <MENU></MENU>
    </div>
</template>
<style>
.el-divider--horizontal {
    margin: 14px 0;
}
.el-loading-spinner i{
    color: #606266;
    font-size: 1.5rem;
}
</style>
<script>
import MENU from '@/components/storeMenu.vue'
import FN from '@/components/fn'

export default {
    components: {
        MENU,
    },
    mixins: [FN],
    data() {
        return {
            activeName: 'first',
            orders: [],
            searchData: {
                page: 1,
                search: '',
                perPage: 15,
            },
            lastPage: 1,
            loading: true,
            loadPage: false,
        }
    },
    mounted() {
        this.dontOpenExternal(false);
    },
    methods: {
        goToOrderDetail(id) {
            this.$router.push({name: 'OrderDetail', params: {id: id}})
        },
        back() {
            this.$router.go(-1)
        },
        getOrderList() {
            this.loadPage = true;
            this.FETCH({
                key: 'GET_ORDER_LIST',
                ...this.searchData
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getOrderList);
                } else if (res.code == 0) {
                    this.addOrders(res.pagination.data);
                    this.lastPage = res.pagination.last_page;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
                this.loading = false;
                this.loadPage = false;
            });

        },
        load() {
            if (this.searchData.page <= this.lastPage) {
                this.getOrderList();
                this.searchData.page++;
            }


        },
        addOrders(datas) {
            datas.forEach((data) => {
                if (!this.orders.some((order) => order.id === data.id)) {
                    this.orders.push(data);
                }
            });
        },
        search() {
            this.loading = true;
            this.orders = [];
            this.searchData.page = 1;
            this.getOrderList();
        },
        /**
         * 停用跳出app功能
         * @param status
         */
        dontOpenExternal(status){
            try {
                window.flutter_inappwebview.callHandler('dontOpenExternal', status).then(function(success) {
                    console.log('停用跳出app功能執行狀態',success);
                })
            } catch (e) {
                console.log('停用跳出app功能-錯誤',e);
            }
        }
    },
    computed: {
        isDetails() {
            const details = this.$route.name !== 'Store'
            return details
        },

    },

}
</script>





